<template>
  <div class="bar_chart"></div>
</template>

<script>
import Highcharts from "highcharts/highstock";
import GLOBAL from "@/utils/global.js";
export default {
  name: "BarChart",
  props: {
    title: {
      required: true,
      default: '',
    },
    yAxisName: {
      required: true,
      default: '',
    },
    xAxisArray: {
      type: Array,
      required: true,
    },
    seriesData: {
      // type: Object,
    },
    count: {},
  },
  data() {
    return {
      GLOBAL,
      chart: null,
    };
  },
  watch: {
    xAxisArray: {
      handler(newValue) {
        // console.log(newValue)
        if (this.chart) {
          this.chart.update({
            xAxis: {
              categories: newValue,
            },
          });
          // this.chart.hideLoading();
        }
      }
    },
    seriesData: function (val) {
      if(!this.$store.state.visitorMode && GLOBAL.debugMode){
        console.log(val);
      }
      if (this.chart) {
        this.chart.update({
          series: [{
            type: 'bar',
            name: val.name,
            data: val.data
          }],

        });
        this.chart.hideLoading();
      }
    },
    count: function (val) {
      let that = this;
      if (this.chart) {
        this.chart.update({
          tooltip: {
            // head + 每个 point + footer 拼接成完整的 table
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormatter() {
              let prev = '<tr><td style="color: rgb(121, 187, 255);padding:0">' + that.seriesData.name + ': </td>' +
                  '<td style="padding:0"><b>' + that.seriesData.data[this.index] + '件</b></td>'+
                  '<tr><td style="color: rgb(121, 187, 255);padding:0">占比: </td><td style="padding:0"><b>';
              let next = '%</b></td></tr>';
              return prev + val[this.index] + next;
            },
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
        });
      }
    },
    title: function (val) {
      if (this.chart) {
        this.chart.update({
          title: {
            text: val,
          }
        });
      }
    },
  },
  mounted() {
    this.initChart();
    this.chart.showLoading();
  },
  methods: {
    initChart() {
      let that = this;
      this.chart = new Highcharts.Chart(this.$el, {
        chart: {
          type: 'bar'
        },
        credits: {
          enabled: false
        },
        title: {
          text: that.title,
        },
        yAxis: {
          title: {
            text: that.yAxisName,
            style: {
              'font-size': '16px',
            }
          },
          // max: 100,
          opposite: true,
        },
        xAxis: {
          categories: that.xAxisArray,
          crosshair: true,
          labels: {
            align: "right",
            style: {
              'font-size': '12px',
            },
            formatter: function () {
              if(this.value.length > 8){
                return this.value.slice(0, 8) + '...';
              } else {
                return this.value;
              }
            }
          },
        },
        legend: {
          itemStyle: {
            'font-size': '16px',
            'font-weight': 'normal',
          }
        },
        series: [{}],
        tooltip: {},
        // plotOptions:{
        //   series: {
        //     events: {
        //       legendItemClick: function () {
        //         // console.log("第"+this.index+"个图例被点击了，是否可见:"+!this.visible);
        //         // return true;
        //         let index = this.index;
        //         let series = this.chart.series;
        //         if(!series[index].visible) {
        //           for(let i=0;i<series.length;i++) {
        //             let s = series[i];
        //             i===index ? s.show() : s.hide();
        //           }
        //         }
        //         return false;
        //       }
        //     }
        //   }
        // },
        colors: ['rgb(121, 187, 255)'],
      });
    },
  },
}
</script>

<style scoped>

</style>
